import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    formataValor,
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTotalTexto,
    formataTableCellBodyExibeDadosTotalValor,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'



const PrevidenciaPrivadaFormPrevidenciaPrivadaBeneficio = ( { beneficios,
    despesaDetutivelAnualPrevidenciaPrivadaCalc, report } ) => {

    const Beneficio = () => {

        let headList = [
            {
                colSpan: 7,
                headTitle: formataTableCellHeadExibeDadosTitulo('', report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.beneficioSemPrevidenciaPrivada, report),
            },
            {
                colSpan: 5,
                headTitle:
                    formataTableCellHeadExibeDadosValor(LABEL.beneficioComPrevidenciaPrivada.replace('$1$',
                        formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2)), report),
            },
        ]

        return (
            <TableExibeDados
                report={report}
                noMinW={true}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {beneficios?.map((item, ind) => {
                        return (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[0].colSpan}
                                    primeiraColuna={true}
                                >
                                    {formataTableCellBodyExibeDadosTotalTexto(item.descricao, report)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[1].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosTotalValor(item.valorSemPrevidenciaPrivada, report)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[2].colSpan}
                                >
                                    {item.valorComPrevidenciaPrivada === 0
                                        ?
                                            formataTableCellBodyExibeDadosTotalTexto(
                                                formataValor(item.valorComPrevidenciaPrivada, 2,
                                                    false, true) , report)
                                        :
                                            formataTableCellBodyExibeDadosTotalValor(
                                                item.valorComPrevidenciaPrivada, report)
                                    }
                                </TableCellBodyExibeDados>
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>  
        )
    }

    return (
        <GridContainer
            className='mt-5 ml-4'
        >
            <GridItem12>
                <Beneficio/>
            </GridItem12>
        </GridContainer>
    )
}

export default PrevidenciaPrivadaFormPrevidenciaPrivadaBeneficio